import React from 'react';

// Context
import { useCompareContext } from '@/context/compare';

// Components
import CompareProduct from '@/braun/components/molecules/CompareProduct';
import CompareProductEmpty from '@/braun/components/molecules/CompareProductEmpty';

const CompareProducts = () => {
  const [{ compareData }] = useCompareContext();
  const { products } = compareData;

  const firstCompareProduct = products[0] ? (
    <CompareProduct productData={products[0]} />
  ) : (
    <CompareProductEmpty />
  );
  const secondCompareProduct = products[1] ? (
    <CompareProduct productData={products[1]} />
  ) : (
    <CompareProductEmpty />
  );
  const thirdCompareProduct = products[2] ? (
    <CompareProduct productData={products[2]} />
  ) : (
    <CompareProductEmpty />
  );

  return (
    <div className='bra-compareTray__products'>
      {firstCompareProduct}
      {secondCompareProduct}
      {thirdCompareProduct}
    </div>
  );
};

export default CompareProducts;
